import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TooltipComponent } from './tooltip.component';
import { SatPopoverModule } from '@ncstate/sat-popover';

@NgModule({
    declarations: [TooltipComponent],
    exports: [TooltipComponent],
    imports: [CommonModule, SatPopoverModule]
})
export class TooltipModule {}
